export const NO_TEAM = 'NO_AVAILABLE_TEAM'

export function getSessionData(session, activeTeamId) {
  const hasSession = Boolean(session?.company_id)
  if (!hasSession) {
    return { sessionToStart: {}, activeTeam: { identifier: activeTeamId } }
  }

  let activeTeam = session.teams.length
    ? session.teams.find((team) => team.identifier === activeTeamId) ||
      session.teams[0]
    : { identifier: NO_TEAM }

  return { sessionToStart: session, activeTeam }
}

export const defaultScenarioTab = () =>
  sessionStorage.getItem('lastScenarioTab') || 'custom'
